import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, AlertTriangle, CalendarClock, CheckCircle2 } from "lucide-react";
import { dateIt } from "./schemas";

const KIND_LABEL = { mezzi: "Mezzo di trasporto", "mezzi-cantiere": "Mezzo di cantiere", attrezzature: "Attrezzatura", esterni: "Personale esterno", interni: "Dipendente" };

// Iter 105: promemoria scadenze (solo in-app, come richiesto)
export default function ScadenzeTab({ giorni = 60, onOpenKind }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/risorse-scadenze", { params: { giorni } })
      .then(({ data }) => setItems(data?.items || []))
      .catch(() => { toast.error("Errore nel caricamento scadenze"); setItems([]); });
  }, [giorni]);

  if (!items) return <div className="flex items-center gap-2 text-slate-500 py-8 justify-center"><Loader2 className="h-5 w-5 animate-spin" /> Caricamento…</div>;
  if (!items.length) {
    return (
      <div className="rounded-xl border border-dashed border-emerald-300 bg-emerald-50 px-4 py-8 text-center text-emerald-700 font-semibold flex items-center justify-center gap-2" data-testid="risorse-scadenze-empty">
        <CheckCircle2 className="h-5 w-5" /> Nessuna scadenza nei prossimi {giorni} giorni
      </div>
    );
  }
  const cls = { scaduto: "border-red-200 bg-red-50 text-red-700", urgente: "border-orange-200 bg-orange-50 text-orange-700", avviso: "border-amber-200 bg-amber-50 text-amber-800" };
  return (
    <div className="space-y-2" data-testid="risorse-scadenze-list">
      <p className="text-xs text-slate-500">Scadenze entro {giorni} giorni: assicurazioni, bollo, revisioni, verifiche periodiche, fine noleggi e contratti.</p>
      {items.map((s, i) => (
        <button
          type="button"
          key={`${s.kind}-${s.id}-${s.campo}`}
          onClick={() => onOpenKind?.(s.kind)}
          className={`w-full text-left flex items-center gap-3 rounded-xl border px-3 py-2.5 ${cls[s.livello]} hover:brightness-95 transition`}
          data-testid={`risorse-scadenza-${i}`}
        >
          {s.livello === "avviso" ? <CalendarClock className="h-5 w-5 shrink-0" /> : <AlertTriangle className="h-5 w-5 shrink-0" />}
          <div className="min-w-0 flex-1">
            <div className="font-bold text-sm truncate">{s.titolo}</div>
            <div className="text-xs opacity-80">{KIND_LABEL[s.kind]} · {s.label}</div>
          </div>
          <div className="text-right shrink-0">
            <div className="font-mono text-sm font-bold">{dateIt(s.data)}</div>
            <div className="text-xs">{s.giorni < 0 ? `scaduto da ${-s.giorni} g` : s.giorni === 0 ? "oggi" : `tra ${s.giorni} g`}</div>
          </div>
        </button>
      ))}
    </div>
  );
}
